
const host = '.nexon.net';

const set = (name, value, days) => {
  if (!days) days = 99;
  let date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = '; expires=' + date.toGMTString();
  const domain = "; domain="+host;
  const path = "; path=/";

  // Set the cookie to the name, value, and expiration
  document.cookie = name + '=' + value + expires + domain + path;
  //console.log('set cookie',name + '=' + value + expires + domain + path)  
}

const get = (name) => {
  let cookieValue = document.cookie,
    cookieStart = cookieValue.indexOf(' ' + name + '=');

  if (cookieStart === -1) {
    cookieStart = cookieValue.indexOf(name + '=');
  }

  if (cookieStart === -1) {
    cookieValue = null;
  } else {
    cookieStart = cookieValue.indexOf('=', cookieStart) + 1;
    let cookieEnd = cookieValue.indexOf(';', cookieStart);

    if (cookieEnd === -1) {
      cookieEnd = cookieValue.length;
    }
    cookieValue = unescape(cookieValue.substring(cookieStart, cookieEnd));
  }

  return cookieValue;
}

export default { set, get } 
